/* eslint-disable camelcase */
import {
  REPORT_CURRENCY_TYPE,
  REPORT_DECIMAL_TYPE,
  REPORT_INTEGER_TYPE,
  REPORT_NUMBER_TYPES
} from 'Components/UI/EAReport/constants'

import {
  formatCurrency,
  formatDecimal,
  formatInteger
} from 'Components/UI/EAReport/utils/format'

const sumColumnByDataIndex = (dataIndex, dataSource = []) =>
  dataSource.reduce((total, record) => {
    const value = record[`${dataIndex}_num`]
    return total + (Number.isFinite(value) ? value : 0)
  }, 0)

const summaryReportData = (columns = [], dataSource = []) =>
  columns.map((column) => {
    const {
      align = 'left',
      dataIndex,
      summary,
      avg,
      quantity_column,
      type
    } = column

    let total = null
    let total_str = '-'

    if (
      (summary === true || avg === true) &&
      REPORT_NUMBER_TYPES.includes(type)
    ) {
      const totalValue = sumColumnByDataIndex(dataIndex, dataSource)

      if (avg === true && quantity_column) {
        const quantityValue = sumColumnByDataIndex(quantity_column, dataSource)
        total = quantityValue > 0 ? totalValue / quantityValue : 0
      } else {
        total = totalValue
      }

      if (type === REPORT_CURRENCY_TYPE) {
        total_str = formatCurrency(total)
      }

      if (type === REPORT_DECIMAL_TYPE) {
        total_str = formatDecimal(total)
      }

      if (type === REPORT_INTEGER_TYPE) {
        total_str = formatInteger(total)
      }
    }

    return { align, dataIndex, total, total_str }
  })

export default summaryReportData
